import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { AbstractDropdown } from '@lt/components';
import { i18n } from '@lt/localization';
import ShareIcon from '@lt/components/icons-react/rebrand/Share';
import ShareSocialButtons from './ShareSocialButtons';

import styles from './shareSocial.module.css';

const SHARE_ICON_SIZE = 16;

// TODO: вынести в компонент дропдаун
const StyledDropdown = styled(AbstractDropdown)`
  position: relative;
  display: inline-block;

  ${AbstractDropdown.StyledContentContainer} {
    position: absolute;
    z-index: 3;
    margin-top: 10px;
    min-width: 190px;
    background-color: var(--white);
    border-radius: var(--border-radius);
    box-shadow: var(--box-shadow);

    ::before {
      position: absolute;
      top: -10px;
      margin-left: 10px;
      width: 0;
      height: 0;
      content: '';
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
    }
  }

  ${({ stickTo }) =>
    stickTo === 'center' &&
    css`
      ${AbstractDropdown.StyledContentContainer} {
        left: calc(50% + ${SHARE_ICON_SIZE}px);
        transform: translateX(-50%);

        ::before {
          left: 50%;
          margin-left: -10px;
        }
      }
    `}
`;

const StyledShareIcon = styled(ShareIcon)`
  margin-right: 2px;
  height: ${SHARE_ICON_SIZE}px;

  path {
    fill: var(--grey1);
  }
`;

const headRenderer = () => (
  <div className={styles.head}>
    <StyledShareIcon type="social-share" />
    <span>{i18n.t('hotel.share')}</span>
  </div>
);

const ShareSocial = ({ description, ...props }) => (
  <StyledDropdown
    {...props}
    headRenderer={headRenderer}
    contentRenderer={() => (
      <ShareSocialButtons networks={['vk']} description={description} />
    )}
  />
);

ShareSocial.propTypes = {
  className: PropTypes.string,
  stickTo: PropTypes.oneOf(['left', 'center']),
  description: PropTypes.string,
};

ShareSocial.defaultProps = {
  className: '',
  stickTo: 'center',
  description: null,
};

export default ShareSocial;
